import { apiSlice } from '../app/api/apiSlice';
import { setSwarmsInActionCounters} from "../store/slices/swarmsInAction";

/**
 * @typedef {Object} RequestActivityAdminToolRes
 * @property {number} swarmId - The ID of the swarm.
 * @property {number} bought - Number of tickets bought.
 * @property {number} pending - Number of tickets pending.
 */

export const requestActivityApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getRequestActivity: builder.query({
      query: () => ({
        url: 'RequestActivity',
        method: 'Get',
      }),
      providesTags: ['RequestActivity'],
    }),

    getCurrentRequestActivityBySwarmId: builder.query({
      query: (swarmId) => ({
        url: `RequestActivity/swarm/${swarmId}/current`,
        method: 'Get',
      }),
      keepUnusedDataFor: 0,
    }),
    getHistoryRequestActivity: builder.query({
      query: (params) => ({
        url: `RequestActivity/${params}`,
        method: 'Get',
      }),
      keepUnusedDataFor: 0,
    }),

    getHistoryRequestActivity: builder.query({
      query: (params) => ({
        url: `RequestActivity/${params}`,
        method: 'Get',
      }),
      keepUnusedDataFor: 0,
    }),

    requestActivityHideEvents: builder.mutation({
      query: (params)=>({
        url: 'RequestActivity/hide-events',
        method: 'post',
        body: params
      }),
      invalidatesTags: ["RequestActivity"]
    }),

    requestActivityUnhideAllEvents: builder.mutation({
      query: ()=>({
        url: 'RequestActivity/unhide-all-events',
        method: 'post',
      }),
      invalidatesTags: ["RequestActivity"]
    }),

    requestActivityResetActivity: builder.mutation({
      query: (params)=>({
        url: 'RequestActivity/reset-activity',
        method: 'post',
        body: params
      }),
      invalidatesTags: ["RequestActivity"]
    })
  })
})

export const { 
  useGetRequestActivityQuery,
  useLazyGetRequestActivityQuery,
  useGetHistoryRequestActivityQuery,
  useLazyGetHistoryRequestActivityQuery,
  useRequestActivityHideEventsMutation,
  useRequestActivityUnhideAllEventsMutation,
  useRequestActivityResetActivityMutation,
  useGetCurrentRequestActivityBySwarmIdQuery
} = requestActivityApi;